import { render, staticRenderFns } from "./login-error.component.vue?vue&type=template&id=932ed420&scoped=true"
import script from "./login-error.component.vue?vue&type=script&lang=ts"
export * from "./login-error.component.vue?vue&type=script&lang=ts"
import style0 from "./login-error.component.vue?vue&type=style&index=0&id=932ed420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932ed420",
  null
  
)

export default component.exports